import { axiosPrivateKIS } from '../api/axiosKIS'
import { useEffect } from 'react'

import useRefreshData from './useRefreshData'
import useAuth from './useAuth'

const useAxiosPrivateKIS = () => {
  const { auth } = useAuth()

  const refresh = useRefreshData()

  useEffect(() => {
    const requestIntercept = axiosPrivateKIS.interceptors.request.use(
      (config) => {
        if (!config.headers['Authorization']) {
          config.headers['Authorization'] = `Bearer ${auth?.token}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    const responseIntercept = axiosPrivateKIS.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config
        if (error?.response?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true
          prevRequest.headers['Authorization'] = `Bearer ${auth.token}`
          return axiosPrivateKIS(prevRequest)
        }
        return Promise.reject(error)
      }
    )

    return () => {
      axiosPrivateKIS.interceptors.request.eject(requestIntercept)
      axiosPrivateKIS.interceptors.response.eject(responseIntercept)
    }
  }, [auth, refresh])

  return axiosPrivateKIS
}

export default useAxiosPrivateKIS
